var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom-icon"},[_c('img-v3',{attrs:{"src":_vm.formItem.icon_url,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"bottom-text"},[_vm._v(_vm._s(_vm.formItem.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }